import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RelatedPlannedOutagesService } from '../services/relatedplanned-outages.service';
import { PlannedOutagesResponse, PlannedOutagesBasicInfo } from '../model/plannedoutagesresponse';
import { CommonConstants } from '../../../../common/constants/common-constants';
@Component ({
    selector : 'zsd-relatedplannedoutages',
    templateUrl : '../view/relatedplanned-outages.component.html',
    styleUrls : ['../view/relatedplanned-outages.component.scss']
})

export class RelatedPlannedOutagesComponent implements OnInit {
    plannedOutageId: number;

    error: string;
    relatedPlannedOutagesCount: number;
    relatedPlannedOutages: Array<PlannedOutagesBasicInfo>;

    constructor(private relatedPlannedOutagesService: RelatedPlannedOutagesService,
        private router: Router, private route: ActivatedRoute) {
        this.error = 'something went wrong';
    }

    ngOnInit() {
        this.route.params.subscribe(
            params => {
                this.plannedOutageId = params['plannedOutageId'];
            });

        this.relatedPlannedOutagesService.getRelatedPlannedOutages(this.plannedOutageId)
            .subscribe(
                (plannedOutagesResponse: PlannedOutagesResponse) => {
                    this.relatedPlannedOutagesCount = plannedOutagesResponse.resultCount;
                    this.relatedPlannedOutages = plannedOutagesResponse.results;
                },
                error => this.error = error
            );
    }

    onClickReason(plannedOutageId: number) {
        this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
            this.router.navigate([CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT + '/' + plannedOutageId]));

    }

}

